import numeral from "numeral";
import { CardHeadgray, CardMain } from "../../../components/card/CardMain";
import {
  STYLE_INPUT,
  STYLE_INPUT_ERROR,
  STYLE_INPUT_SLIDER,
  STYLE_PADDING_MAIN,
  STYLE_SPACE_GRAY_MENU,
} from "../../../utils/useStyle";
import { ViewTableDebt } from "../../debt/component/VIDebtTable";
import { MTButton } from "../../../components/button/MTButton";
import { useRetireStore } from "../../../_store/retireStore";
import { useBalanceStore } from "../../../_store/balanceStore";
import { NumericFormat } from "react-number-format";
import { useFuturePlanStore } from "../../../_store/futurePlanStore";
import { cn } from "../../../utils/useFunctions";
import NumbericValidateRed from "../../../components/DebtBalance/numericRed";
import ErrorMain from "../../../components/error/Error.Main";
import { SliderSingle } from "../../../components/slider/SliderSingle";
import { useState } from "react";

const ProfileUser = ({ onChangeForm }) => {
  const retireData = useRetireStore((state) => state.retireData);
  const futurePlan = useFuturePlanStore((state) => state.futurePlanData);

  return (
    <div>
      <div className=" text-center text-black font-semibold text-xl mb-5">
        ข้อมูลปัจจุบัน
      </div>
      <div className=" grid grid-cols-3 justify-center items-center">
        <div className=" mx-auto flex flex-col justify-center items-center gap-1">
          <img
            alt="present_age"
            src="/images/present_age2.png"
            className=" mx-auto w-[50px] h-[50px]"
          />
          <div className="mt-2 text-sm font-semibold text-maincyan">
            อายุปัจจุบัน
          </div>
          <div className="text-mainblue font-bold">
            {/* {retireData?.age_current || 25} ปี */}
            <NumericFormat
              maxLength={11}
              placeholder="0"
              thousandSeparator=","
              inputMode="decimal"
              pattern="[0-9],*"
              className={STYLE_INPUT_SLIDER}
              value={futurePlan?.age_current || ""}
              onChange={onChangeForm("age_current")}
            />
          </div>
        </div>
        <div className=" mx-auto flex flex-col justify-center items-center gap-1">
          <img
            alt=""
            src="/images/old_age2.png"
            className=" mx-auto w-[50px] h-[50px]"
          />
          <div className="mt-2 text-sm font-semibold text-[#B95940]">
            อายุเกษียณ
          </div>
          <div className="text-mainblue font-bold">
            {/* {retireData?.age_retire || 60} ปี */}
            <NumericFormat
              maxLength={11}
              placeholder="0"
              thousandSeparator=","
              inputMode="decimal"
              pattern="[0-9],*"
              className={STYLE_INPUT_SLIDER}
              value={futurePlan?.age_retire || ""}
              onChange={onChangeForm("age_retire")}
            />
          </div>
        </div>
        <div className=" mx-auto flex flex-col justify-center items-center gap-1">
          <img
            alt=""
            src="/images/dead2.png"
            className=" mx-auto w-[50px] h-[50px]"
          />
          <div className="mt-2 text-sm font-semibold text-mainorange">
            สิ้นอายุขัย
          </div>
          <div className="text-mainblue font-bold text-center">
            {/* {retireData?.age_dead || 80} ปี */}
            <NumericFormat
              maxLength={11}
              placeholder="0"
              thousandSeparator=","
              inputMode="decimal"
              pattern="[0-9],*"
              className={STYLE_INPUT_SLIDER}
              value={futurePlan?.age_dead || ""}
              onChange={onChangeForm("age_dead")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const FutureProfile = ({
  age_current,
  age_retire,
  age_dead,
  salary,
  salary_peryear,
  out_come,
  investment_assets,
  debt_short_list,
  debt_long_list,
  onClick,
  onChangeForm,
}) => {
  const retireData = useRetireStore((state) => state.retireData);
  const balanceData = useBalanceStore((state) => state.balanceData);
  const futurePlan = useFuturePlanStore((state) => state.futurePlanData);

  const [error, setError] = useState({
    salary: false,
  });

  return (
    <div className={`${STYLE_SPACE_GRAY_MENU} ${STYLE_PADDING_MAIN}`}>
      <ProfileUser onChangeForm={onChangeForm} />
      {/* <CardHeadgray
        title={"เงินเดือน/ต่อเดือน "}
        text_color="text-mainblue font-semibold text-xl"
        panel={
          <div className=" py-5 flex justify-center items-center space-x-1">
            <NumbericValidateRed
              placeholder="0"
              className={cn(STYLE_INPUT_SLIDER, "w-32")}
              value={futurePlan?.salary || ""}
              onChange={onChangeForm("salary")}
            />
            <div>บาท</div>
          </div>
        }
      /> */}
      <CardMain
        // onClick={() => {
        //   setOpenSalary(true);
        // }}
        icon={false}
        title="เงินเดือน (บาท/เดือน) "
        margin=""
        mb="mb-[21px]"
        panel={
          <div className=" px-2">
            <NumericFormat
              value={Number(futurePlan?.salary || 0)}
              onChange={onChangeForm("salary")}
              maxLength={11}
              placeholder="25,000"
              thousandSeparator=","
              inputMode="decimal"
              pattern="[0-9],*"
              className={error?.salary ? STYLE_INPUT_ERROR : STYLE_INPUT}
            />
            {error?.salary && (
              <ErrorMain errortext="กรุณากรอกเงินเดือน ถ้าไม่มีเงินเดือนกรุณากรอกเลข 0" />
            )}
          </div>
        }
      />
      {/* <CardHeadgray
        title={"อัตราเงินเดือนที่เพิ่มขึ้นต่อปี (%) "}
        text_color="text-mainblue font-semibold text-xl"
        panel={
          <div className=" py-5 flex justify-center items-center space-x-1">
            <NumbericValidateRed
              placeholder="0"
              className={cn(STYLE_INPUT_SLIDER, "w-32")}
              value={futurePlan?.salary_peryear || ""}
              onChange={onChangeForm("salary_peryear")}
            />
            <div>%</div>
          </div>
        }
      /> */}

      <CardMain
        icon={false}
        title="อัตราเงินเดือนที่เพิ่มขึ้นต่อปี (%)"
        margin=""
        mb="mb-2.5"
        panel={
          <div className=" px-4">
            <div className=" flex justify-center">
              <NumericFormat
                maxLength={11}
                min={1}
                thousandSeparator=","
                inputMode="decimal"
                pattern="[0-9],*"
                placeholder="0"
                className={STYLE_INPUT_SLIDER}
                value={futurePlan?.salary_peryear}
                onChange={onChangeForm("salary_peryear")}
              />
            </div>
            <SliderSingle
              placeholder="0"
              valuemax={100}
              value={futurePlan?.salary_peryear}
              onChange={onChangeForm("salary_peryear")}
              onChangeMax={onChangeForm("salary_peryear_max")}
              valuemin={1}
              disabledMax={true}
            />
            {error?.salary_peryear && (
              <ErrorMain errortext="กรุณากรอกอัตราเงินเดือนที่เพิ่มขึ้นต่อปี ถ้าไม่มีอัตราเงินเดือนที่เพิ่มขึ้นต่อปีกรุณากรอกเลข 0" />
            )}
            {error?.salary_peryear_max && (
              <ErrorMain errortext="กรุณากรอกอัตราเงินเดือนที่เพิ่มขึ้นต่อปี" />
            )}
          </div>
        }
      />

      {/* <CardHeadgray
        title={"รายรับอื่น ๆ"}
        text_color="text-mainblue font-semibold text-xl"
        panel={
          <div className=" py-5 flex justify-center items-center space-x-1">
            <NumbericValidateRed
              placeholder="0"
              className={cn(STYLE_INPUT_SLIDER, "w-32")}
              value={futurePlan?.other_income || 0}
              onChange={onChangeForm("other_income")}
            />
            <div>บาท</div>
          </div>
        }
      /> */}

      <CardMain
        // onClick={() => {
        //   setOpenSalary(true);
        // }}
        icon={false}
        title="รายรับอื่น ๆ ต่อเดือน"
        margin=""
        mb="mb-[21px]"
        panel={
          <div className=" px-2">
            <NumericFormat
              value={Number(futurePlan?.other_income || 0)}
              onChange={onChangeForm("other_income")}
              maxLength={11}
              decimalScale={2}
              placeholder="25,000"
              thousandSeparator=","
              inputMode="decimal"
              pattern="[0-9],*"
              className={error?.other_income ? STYLE_INPUT_ERROR : STYLE_INPUT}
            />
            {error?.other_income && (
              <ErrorMain errortext="กรุณากรอกรายรับอื่น ๆ ถ้าไม่มีรายรับอื่น ๆกรุณากรอกเลข 0" />
            )}
          </div>
        }
      />

      <CardMain
        icon={false}
        title="รายรับอื่น ๆ ที่เพิ่มขึ้นต่อปี"
        margin=""
        mb="mb-2.5"
        panel={
          <div className=" px-4">
            <div className=" flex justify-center">
              <NumericFormat
                maxLength={11}
                min={1}
                thousandSeparator=","
                inputMode="decimal"
                pattern="[0-9],*"
                placeholder="0"
                className={STYLE_INPUT_SLIDER}
                value={futurePlan?.other_income_growth}
                onChange={onChangeForm("other_income_growth")}
              />
            </div>
            <SliderSingle
              placeholder="0"
              // valuemax={futurePlan?.other_income_growth_max || 20}
              valuemax={100}
              disabledMax={true}
              value={futurePlan?.other_income_growth}
              onChange={onChangeForm("other_income_growth")}
              onChangeMax={onChangeForm("other_income_growth_max")}
              valuemin={1}
            />
            {error?.other_income_growth && (
              <ErrorMain errortext="กรุณากรอกเงินเดือนที่เพิ่มขึ้นต่อปี ถ้าไม่มีเงินเดือนกรุณากรอกเลข 0" />
            )}
            {error?.other_income_growth_max && (
              <ErrorMain errortext="กรุณากรอกเงินเดือนที่เพิ่มขึ้นต่อปี" />
            )}
          </div>
        }
      />

      <CardMain
        icon={false}
        title="คาดการณ์ระยะเวลาที่จะมีรายรับอื่น ๆ"
        margin=""
        mb="mb-2.5"
        panel={
          <div className=" px-4">
            <div className=" flex justify-center">
              <NumericFormat
                maxLength={11}
                min={1}
                thousandSeparator=","
                inputMode="decimal"
                pattern="[0-9],*"
                placeholder="0"
                className={STYLE_INPUT_SLIDER}
                value={futurePlan?.salary_peryear_duration}
                onChange={onChangeForm("salary_peryear_duration")}
              />
            </div>
            <SliderSingle
              placeholder="0"
              // valuemax={futurePlan?.salary_peryear_duration_max || 20}
              valuemax={100}
              disabledMax={true}
              value={futurePlan?.salary_peryear_duration}
              onChange={onChangeForm("salary_peryear_duration")}
              onChangeMax={onChangeForm("salary_peryear_duration_max")}
              valuemin={1}
              year={true}
            />
            {error?.salary_peryear_duration && (
              <ErrorMain errortext="กรุณากรอกระยะเวลาที่จะมีรายรับอื่น ๆ ถ้าไม่มีเงินเดือนกรุณากรอกเลข 0" />
            )}
            {error?.salary_peryear_duration_max && (
              <ErrorMain errortext="กรุณากรอกระยะเวลาที่จะมีรายรับอื่น ๆ" />
            )}
          </div>
        }
      />

      {/* <CardHeadgray
        title={"รายจ่ายคงที่/เดือน (ไม่รวมเงินผ่อนชำระหนี้สินคงค้างรายงวด)"}
        text_color="text-mainblue font-semibold text-xl"
        panel={
          <div className=" py-5 flex justify-center items-center space-x-1">
            <NumbericValidateRed
              placeholder="0"
              className={cn(STYLE_INPUT_SLIDER, "w-32")}
              value={futurePlan?.out_come_stable || ""}
              onChange={onChangeForm("out_come_stable")}
            />
            <div>บาท</div>
          </div>
        }
      /> */}

      <CardMain
        icon={false}
        title="รายจ่ายคงที่/เดือน (ไม่รวมเงินผ่อนชำระหนี้สินคงค้างรายงวด)"
        margin=""
        mb="mb-[21px]"
        panel={
          <div className=" px-2">
            <NumericFormat
              value={Number(futurePlan?.out_come_stable || 0)}
              onChange={onChangeForm("out_come_stable")}
              maxLength={11}
              placeholder="25,000"
              thousandSeparator=","
              inputMode="decimal"
              pattern="[0-9],*"
              className={
                error?.out_come_stable ? STYLE_INPUT_ERROR : STYLE_INPUT
              }
            />
            {error?.out_come_stable && (
              <ErrorMain errortext="กรุณากรอกรายจ่ายคงที่ ถ้าไม่มีรายจ่ายคงที่กรุณากรอกเลข 0" />
            )}
          </div>
        }
      />

      <div className=" text-black font-semibold ">รายการหนี้สินทั้งหมด</div>
      <ViewTableDebt
        debtShortList={balanceData?.debt_short_list}
        debtLongList={balanceData?.debt_long_list}
      />

      {/* <CardHeadgray
        title={" รายจ่ายแปรผัน/เดือน"}
        text_color="text-mainblue font-semibold text-xl"
        panel={
          <div className=" py-5 flex justify-center items-center space-x-1">
            <NumbericValidateRed
              placeholder="0"
              className={cn(STYLE_INPUT_SLIDER, "w-32")}
              value={futurePlan?.out_come || ""}
              onChange={onChangeForm("out_come")}
            />
            <div>บาท</div>
          </div>
        }
      /> */}

      <CardMain
        icon={false}
        title={"รายจ่ายแปรผัน/เดือน"}
        margin=""
        mb="mb-[21px]"
        panel={
          <div className=" px-2">
            <NumericFormat
              value={Number(futurePlan?.out_come || 0)}
              onChange={onChangeForm("out_come")}
              maxLength={11}
              placeholder="25,000"
              thousandSeparator=","
              inputMode="decimal"
              pattern="[0-9],*"
              className={error?.out_come ? STYLE_INPUT_ERROR : STYLE_INPUT}
            />
            {error?.out_come && (
              <ErrorMain errortext="กรุณากรอกรายจ่ายแปรผัน ถ้าไม่มีรายจ่ายแปรผันกรุณากรอกเลข 0" />
            )}
          </div>
        }
      />

      <CardMain
        icon={false}
        title="อัตรารายจ่ายผันแปรที่เพิ่มขึ้นต่อปี (%)"
        margin=""
        mb="mb-2.5"
        panel={
          <div className=" px-4">
            <div className=" flex justify-center">
              <NumericFormat
                maxLength={11}
                min={1}
                thousandSeparator=","
                inputMode="decimal"
                pattern="[0-9],*"
                placeholder="0"
                className={STYLE_INPUT_SLIDER}
                value={futurePlan?.out_come_peryear}
                onChange={onChangeForm("out_come_peryear")}
              />
            </div>
            <SliderSingle
              placeholder="0"
              // valuemax={futurePlan?.out_come_peryear_max || 20}
              valuemax={100}
              disabledMax={true}
              value={futurePlan?.out_come_peryear}
              onChange={onChangeForm("out_come_peryear")}
              onChangeMax={onChangeForm("out_come_peryear_max")}
              valuemin={1}
            />
            {error?.out_come_peryear && (
              <ErrorMain errortext="กรุณากรอกอัตรารายจ่ายผันแปรที่เพิ่มขึ้นต่อปี (%) ถ้าไม่มีเงินเดือนกรุณากรอกเลข 0" />
            )}
            {error?.out_come_peryear_max && (
              <ErrorMain errortext="กรุณากรอกอัตรารายจ่ายผันแปรที่เพิ่มขึ้นต่อปี (%)" />
            )}
          </div>
        }
      />

      {/* <CardHeadgray
        title={"สินทรัพย์ลงทุน"}
        text_color="text-mainblue font-semibold text-xl"
        panel={
          <div className=" py-5 flex justify-center items-center space-x-1">
            <NumbericValidateRed
              placeholder="0"
              className={cn(STYLE_INPUT_SLIDER, "w-32")}
              value={futurePlan?.income_investment || ""}
              onChange={onChangeForm("income_investment")}
            />
            <div>บาท</div>
          </div>
        }
      /> */}

      <CardMain
        icon={false}
        title={"สินทรัพย์ลงทุน"}
        margin=""
        mb="mb-[21px]"
        panel={
          <div className=" px-2">
            <NumericFormat
              value={Number(futurePlan?.income_investment || 0)}
              onChange={onChangeForm("income_investment")}
              maxLength={11}
              placeholder="25,000"
              thousandSeparator=","
              inputMode="decimal"
              pattern="[0-9],*"
              className={
                error?.income_investment ? STYLE_INPUT_ERROR : STYLE_INPUT
              }
            />
            {error?.income_investment && (
              <ErrorMain errortext="กรุณากรอกสินทรัพย์ลงทุน ถ้าไม่มีสินทรัพย์ลงทุนกรุณากรอกเลข 0" />
            )}
          </div>
        }
      />

      <CardMain
        icon={false}
        title="อัตราผลตอบแทนการลงทุนเฉลี่ย (%)"
        margin=""
        mb="mb-2.5"
        panel={
          <div className=" px-4">
            <div className=" flex justify-center">
              <NumericFormat
                maxLength={11}
                min={1}
                thousandSeparator=","
                inputMode="decimal"
                pattern="[0-9],*"
                placeholder="0"
                className={STYLE_INPUT_SLIDER}
                value={futurePlan?.income_investment_percent}
                onChange={onChangeForm("income_investment_percent")}
              />
            </div>
            <SliderSingle
              placeholder="0"
              // valuemax={futurePlan?.income_investment_percent_max || 20}
              valuemax={100}
              disabledMax={true}
              value={futurePlan?.income_investment_percent}
              onChange={onChangeForm("income_investment_percent")}
              onChangeMax={onChangeForm("income_investment_percent_max")}
              valuemin={1}
            />
            {error?.income_investment_percent && (
              <ErrorMain errortext="กรุณากรอกอัตรารายจ่ายผันแปรที่เพิ่มขึ้นต่อปี (%) ถ้าไม่มีเงินเดือนกรุณากรอกเลข 0" />
            )}
            {error?.income_investment_percent_max && (
              <ErrorMain errortext="กรุณากรอกอัตรารายจ่ายผันแปรที่เพิ่มขึ้นต่อปี (%)" />
            )}
          </div>
        }
      />

      {/* <CardHeadgray
        title={"เงินบำนาญ "}
        text_color="text-mainblue font-semibold text-xl"
        panel={
          <div className=" py-5 flex justify-center items-center space-x-1">
            <NumbericValidateRed
              placeholder="0"
              className={cn(STYLE_INPUT_SLIDER, "w-32")}
              value={futurePlan?.pension_peryear || ""}
              onChange={onChangeForm("pension_peryear")}
            />
            <div>บาท</div>
          </div>
        }
      /> */}

      <CardMain
        icon={false}
        title={"เงินบำนาญต่อเดือน"}
        margin=""
        mb="mb-[21px]"
        panel={
          <div className=" px-2">
            <NumericFormat
              value={Number(futurePlan?.pension_peryear || 0)}
              onChange={onChangeForm("pension_peryear")}
              maxLength={11}
              placeholder="25,000"
              thousandSeparator=","
              inputMode="decimal"
              pattern="[0-9],*"
              className={
                error?.pension_peryear ? STYLE_INPUT_ERROR : STYLE_INPUT
              }
            />
            {error?.pension_peryear && (
              <ErrorMain errortext="กรุณากรอกเงินบำนาญ ถ้าไม่มีเงินบำนาญกรุณากรอกเลข 0" />
            )}
          </div>
        }
      />

      <div className=" flex justify-center items-center">
        <MTButton
          text={"วางแผนอนาคต"}
          color="bg-maincyan"
          width="w-40"
          onClick={onClick}
        />
      </div>
    </div>
  );
};

export default FutureProfile;
